<script setup>
import DsAddressFieldDawa from './DsAddressFieldDawa.vue';
import DsAddressFieldJix from './DsAddressFieldJix.vue';

defineEmits(['update:modelValue', 'dawa-selected']);

const FieldComponent = !/dk$/.test(window.Stash.common.site)
    ? DsAddressFieldJix
    : DsAddressFieldDawa;

</script>
<template>
    <FieldComponent
        @update:model-value="$emit('update:modelValue', $event)"
        @dawa-selected="$emit('dawa-selected', $event)"
    />
</template>
